import React from 'react'

function Water() {
  return (
    <>
    <section class="projects-section bg-light" id="water">
                <div class="container px-4 px-lg-5">
                    {/* <!-- Featured Project Row--> */}
                    <div class="row gx-0 mb-4 mb-lg-5 align-items-center">
                        <div class="col-xl-1 col-lg-7"></div>
                        <div class="col-xl-4 col-lg-5">
                            <div class="featured-text text-center text-lg-left">
                                <h4>Recommended Drinks</h4>
                                <p class="text-black-50 mb-0">เป็นที่นิยมในหมวดเครื่องดื่ม</p>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Project One Row--> */}
                    <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                        <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/d1.jpg" alt="..." /></div>
                        <div class="col-lg-6">
                            <div class="bg-black text-center h-100 project">
                                <div class="d-flex h-100">
                                    <div class="project-text w-100 my-auto text-center text-lg-left">
                                        <h4 class="text-white">ทอฟฟี่นัท คาราเมล / -80 ฿ </h4>
                                        <p class="mb-0 text-white-50">"นมสดปั่น ผสมไซรัปกลิ่นวนิลลา หอมละมุนมาก ท็อปด้วยวิปครีมนุ่มๆ สูตรเฉพาะของทางร้าน หวานน้อย ราดด้วยซอสคาราเมล ตบท้ายโรยด้วยคุกกี้ครัมเบิ้ลกรุบๆ หอมเนย สุดฟิน"</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Project Two Row--> */}
                    <div class="row gx-0 justify-content-center">
                        <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/d2.jpg" alt="..." /></div>
                        <div class="col-lg-6 order-lg-first">
                            <div class="bg-black text-center h-100 project">
                                <div class="d-flex h-100">
                                    <div class="project-text w-100 my-auto text-center text-lg-right">
                                        <h4 class="text-white">สตรอว์เบอร์รีชีสเค้กปั่น / -75 ฿ </h4>
                                        <p class="mb-0 text-white-50">"รสชาติหวานละมุน หอมกลิ่นชีสเค้ก มีครัมเบิ้ล และซอสสตรอว์เบอร์รีสูตรโฮมเมดของที่ร้าน เข้ามาช่วยเสริมความอร่อย ดูดเพลิน อร่อยลงตัวมาก"</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-0 mb-5 mb-lg-0 justify-content-center">
                        <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/d3.jpg" alt="..." /></div>
                        <div class="col-lg-6">
                            <div class="bg-black text-center h-100 project">
                                <div class="d-flex h-100">
                                    <div class="project-text w-100 my-auto text-center text-lg-left">
                                        <h4 class="text-white">สตรอว์เบอร์รีชาเขียวลาเต้ / -70 ฿</h4>
                                        <p class="mb-0 text-white-50">"เมนูเครื่องดื่มซิกเนเจอร์ของที่ร้าน ชาเขียวแสนอร่อย ผสมผสานกับนมสด ด้านล่างเป็นซอสสตรอว์เบอร์รีสูตรเฉพาะของที่ร้าน ทานรวมกันทั้งสามเลเยอร์ รสชาติหอม หวาน โดนใจ แนะนำต้องมาลอง"</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Project Two Row--> */}
                    <div class="row gx-0 justify-content-center">
                        <div class="col-lg-6"><img class="img-fluid" src="assets/img/recom/d4.jpg" alt="..." /></div>
                        <div class="col-lg-6 order-lg-first">
                            <div class="bg-black text-center h-100 project">
                                <div class="d-flex h-100">
                                    <div class="project-text w-100 my-auto text-center text-lg-right">
                                        <h4 class="text-white">ทุ่งหญ้า ท้องฟ้า และก้อนเมฆ  / -80 ฿</h4>
                                        <p class="mb-0 text-white-50">"เมนูเครื่องดื่มสุดฮิต น่ารัก น่าดื่ม ชั้นล่างเป็นมัทฉะเข้มอร่อย ดื่มรวมกับชั้นของนมสดอัญชัน ท็อปด้วยวิปครีม อร่อยลงตัวมาก"</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
    </>
  )
}

export default Water